function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078431%,43.529412%,80.392157%)",
      fillOpacity: 1
    },
    d: "M 0 60.703125 L 0 9.242188 C 0.0195312 8.335938 0.75 7.605469 1.652344 7.589844 L 79.675781 7.589844 C 80.578125 7.605469 81.308594 8.335938 81.328125 9.242188 L 81.328125 60.710938 Z M 0 60.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 81.328125 60.703125 L 81.328125 67.3125 C 81.308594 68.21875 80.578125 68.945312 79.675781 68.964844 L 1.652344 68.964844 C 0.746094 68.945312 0.0195312 68.21875 0 67.3125 L 0 60.703125 Z M 81.328125 60.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 23.253906 80.648438 L 58.074219 80.648438 L 58.074219 82.300781 L 23.253906 82.300781 Z M 23.253906 80.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(66.666667%,75.686275%,80.784314%)",
      fillOpacity: 1
    },
    d: "M 52.226562 80.65625 L 29.097656 80.65625 L 30.75 68.964844 L 50.574219 68.964844 Z M 52.226562 80.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.304688 10.894531 L 78.015625 10.894531 L 78.015625 57.398438 L 3.304688 57.398438 Z M 3.304688 10.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.509804%,62.745098%,68.235294%)",
      fillOpacity: 1
    },
    d: "M 50.574219 68.964844 L 30.75 68.964844 L 29.828125 75.488281 L 50.871094 71.066406 Z M 50.574219 68.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078431%,43.529412%,80.392157%)",
      fillOpacity: 1
    },
    d: "M 85.8125 82.410156 L 64.125 82.410156 C 61.816406 82.40625 59.941406 80.53125 59.9375 78.222656 L 59.9375 32.484375 C 59.941406 30.175781 61.816406 28.300781 64.125 28.296875 L 85.8125 28.296875 C 88.121094 28.300781 89.996094 30.175781 90 32.484375 L 90 78.222656 C 89.992188 80.535156 88.121094 82.40625 85.8125 82.410156 Z M 85.8125 82.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 61.917969 32.570312 L 88.015625 32.570312 L 88.015625 75.242188 L 61.917969 75.242188 Z M 61.917969 32.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 78.878906 30.878906 L 73.546875 30.878906 C 73.304688 30.878906 73.113281 30.683594 73.109375 30.441406 C 73.113281 30.203125 73.304688 30.007812 73.546875 30.007812 L 78.890625 30.007812 C 79.132812 30.007812 79.324219 30.203125 79.328125 30.441406 C 79.324219 30.683594 79.128906 30.878906 78.886719 30.878906 C 78.886719 30.878906 78.882812 30.878906 78.878906 30.878906 Z M 78.878906 30.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 71.492188 30.441406 C 71.492188 30.679688 71.296875 30.875 71.058594 30.875 C 70.816406 30.875 70.621094 30.679688 70.621094 30.441406 C 70.621094 30.199219 70.816406 30.003906 71.058594 30.003906 C 71.296875 30.003906 71.492188 30.199219 71.492188 30.441406 Z M 71.492188 30.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,86.27451%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 74.96875 80.886719 C 73.828125 80.886719 72.902344 79.964844 72.902344 78.824219 C 72.902344 77.683594 73.828125 76.761719 74.96875 76.761719 C 76.105469 76.761719 77.03125 77.683594 77.03125 78.824219 C 77.027344 79.960938 76.105469 80.882812 74.96875 80.886719 Z M 74.96875 77.183594 C 74.058594 77.183594 73.324219 77.917969 73.324219 78.824219 C 73.324219 79.730469 74.058594 80.464844 74.96875 80.464844 C 75.875 80.464844 76.609375 79.730469 76.609375 78.824219 C 76.605469 77.917969 75.871094 77.183594 74.96875 77.183594 Z M 74.96875 77.183594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.83c580e9b8619769ecf53d5073493480.svg";
export { ForwardRef as ReactComponent };